import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function FadeInSection({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 24
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-906">
      {children}
    </motion.div>;
}
export function PrivacyPage() {
  return <div className="bg-charcoal min-h-screen" data-id="element-907">
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-908">
        <div className="max-w-3xl mx-auto" data-id="element-909">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-910">
            <h1 className="text-3xl sm:text-4xl font-bold text-cream mb-3" data-id="element-911">
              Política de Privacidad
            </h1>
            <p className="text-sm text-[#7a7672] mb-12" data-id="element-912">
              Última actualización: enero 2025
            </p>
          </motion.div>

          <div className="space-y-10" data-id="element-913">
            <FadeInSection data-id="element-914">
              <div data-id="element-915">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-916">
                  1. Información que recopilamos
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-917">
                  Reclutas Digitales recopila información que usted nos
                  proporciona directamente, como nombre, dirección de correo
                  electrónico, número de teléfono y cualquier otra información
                  que decida compartir al completar formularios en nuestro sitio
                  web o al comunicarse con nosotros. También podemos recopilar
                  información automáticamente sobre su dispositivo y cómo
                  interactúa con nuestros servicios.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.05} data-id="element-918">
              <div data-id="element-919">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-920">
                  2. Uso de cookies y tecnologías similares
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-921">
                  Utilizamos cookies y tecnologías de seguimiento similares para
                  mejorar su experiencia en nuestro sitio, analizar el tráfico y
                  personalizar el contenido. Puede controlar el uso de cookies a
                  través de la configuración de su navegador. Al continuar
                  utilizando nuestro sitio, acepta el uso de cookies de acuerdo
                  con esta política.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.1} data-id="element-922">
              <div data-id="element-923">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-924">
                  3. Cómo usamos su información
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm mb-3" data-id="element-925">
                  Utilizamos la información recopilada para los siguientes
                  propósitos:
                </p>
                <ul className="space-y-2 text-sm text-[#b8b4ae]" data-id="element-926">
                  <li className="flex items-start gap-2" data-id="element-927">
                    <span className="text-accent mt-0.5" data-id="element-928">•</span> Proporcionar,
                    mantener y mejorar nuestros servicios
                  </li>
                  <li className="flex items-start gap-2" data-id="element-929">
                    <span className="text-accent mt-0.5" data-id="element-930">•</span> Comunicarnos
                    con usted sobre nuestros servicios y actualizaciones
                  </li>
                  <li className="flex items-start gap-2" data-id="element-931">
                    <span className="text-accent mt-0.5" data-id="element-932">•</span> Responder a
                    sus consultas y solicitudes de soporte
                  </li>
                  <li className="flex items-start gap-2" data-id="element-933">
                    <span className="text-accent mt-0.5" data-id="element-934">•</span> Analizar el
                    uso del sitio para mejorar la experiencia del usuario
                  </li>
                  <li className="flex items-start gap-2" data-id="element-935">
                    <span className="text-accent mt-0.5" data-id="element-936">•</span> Cumplir con
                    obligaciones legales aplicables
                  </li>
                </ul>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.15} data-id="element-937">
              <div data-id="element-938">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-939">
                  4. Compartir información con terceros
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-940">
                  No vendemos ni alquilamos su información personal a terceros.
                  Podemos compartir su información con proveedores de servicios
                  de confianza que nos ayudan a operar nuestro negocio, siempre
                  bajo acuerdos de confidencialidad.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.2} data-id="element-941">
              <div data-id="element-942">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-943">
                  5. Seguridad de datos
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-944">
                  Implementamos medidas de seguridad técnicas y organizativas
                  razonables para proteger su información personal contra acceso
                  no autorizado, pérdida o divulgación.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.25} data-id="element-945">
              <div data-id="element-946">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-947">
                  6. Sus derechos
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-948">
                  Dependiendo de su ubicación, puede tener ciertos derechos con
                  respecto a su información personal, incluyendo el derecho a
                  acceder, corregir o eliminar sus datos.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.3} data-id="element-949">
              <div data-id="element-950">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-951">
                  7. Cambios a esta política
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-952">
                  Podemos actualizar esta política de privacidad periódicamente.
                  Le notificaremos sobre cambios significativos publicando la
                  nueva política en esta página con una fecha de actualización
                  revisada.
                </p>
              </div>
            </FadeInSection>

            <FadeInSection delay={0.35} data-id="element-953">
              <div data-id="element-954">
                <h2 className="text-xl font-semibold text-cream mb-3" data-id="element-955">
                  8. Contacto
                </h2>
                <p className="text-[#b8b4ae] leading-relaxed text-sm" data-id="element-956">
                  Si tiene preguntas sobre esta política de privacidad, puede
                  contactarnos a través del formulario de contacto en nuestro
                  sitio web.
                </p>
              </div>
            </FadeInSection>
          </div>
        </div>
      </section>
    </div>;
}